import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { delayHttpRequest } from '../helpers/globalHelper'
import { paycheckservice } from '../services/paycheckservice'
import {
  PiechartEarnings,
  currentweekData,
  depositData,
  paycheckbody,
  paycheckdetails,
  resource,
  w2details
} from '../types/paycheckTypes'

type Store = {
  paycheckData: paycheckdetails
  loading: boolean
  piechartData: PiechartEarnings
  currentweekData: currentweekData
  error: null
  w2formsData: w2details
  resourceData: resource
  depositData: depositData
  downloadFile: (uri: string) => void
  paycheck: (data: paycheckbody) => void
  fetchCurrentWeekEarnings: (
    essUserKey: number,
    essobKey: number,
    employeeNumber: number,
    userId: number
  ) => void
  fetchW2Forms: (
    entityid,
    empnumber,
    essUserKey,
    obkey,
    CorpId,
    storeId
  ) => void
  updateDirectDeposit: (
    amount,
    essUserKey,
    accountnumber,
    AccountType,
    RoutingNumber,
    data,
    bank
  ) => void
  getDepositDetails: (essUserKey) => any
  getEmployeeResources: (essUserKey) => void
  clearData: () => void
  editDepositDetails: (
    amount,
    userkey,
    accountnumber,
    accounttype,
    routingnumber,
    depositkey,
    imgdata,
    bank
  ) => void
  deleteDepositDetails: (depositkey) => void
  getpdfblob: (payid, employeenumber) => any
  fetchw2file: (w2id, essuserkey, obkey, year, isCorrectionW2, seqNo) => any
  getpdfbase64: (storepolicykey) => any
  fetchBankNameByRoutingNumber:(routingNumber: string) => any
}

const usepaycheckStore = create(
  devtools<Store>((set) => ({
    loading: false,
    error: null,
    currentweekData: null,
    resourceData: null,
    piechartData: null,
    paycheckData: null,
    depositData: null,
    w2formsData: null,
    downloadFile: async (data) => {
      const downloadData = await paycheckservice.downloadFile(data)
    },
    paycheck: async (data: paycheckbody) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        const _paycheckData = await paycheckservice.paycheck(data)
        set((state) => ({ ...state, paycheckData: _paycheckData }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },

    fetchCurrentWeekEarnings: async (
      essUserKey: number,
      essobKey: number,
      employeeNumber: number,
      userId: number
    ) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        const _Data = await paycheckservice.fetchCurrentWeekEarnings(
          essUserKey,
          essobKey,
          employeeNumber,
          userId
        )
        set((state) => ({ ...state, currentweekData: _Data }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    fetchW2Forms: async (
      entityid,
      empnumber,
      essUserKey,
      obkey,
      CorpId,
      storeId
    ) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        const _Data = await paycheckservice.fetchW2Forms(
          entityid,
          empnumber,
          essUserKey,
          obkey,
          CorpId,
          storeId
        )
        set((state) => ({ ...state, w2formsData: _Data }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },

    updateDirectDeposit: async (
      amount,
      essUserKey,
      accountnumber,
      AccountType,
      RoutingNumber,
      data,
      bank
    ) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await paycheckservice.updateDirectDeposit(
          amount,
          essUserKey,
          accountnumber,
          AccountType,
          RoutingNumber,
          data,
          bank
        )
        //set((state)=>({...state,depositData:_Data}))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    getDepositDetails: async (essUserKey) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        const _Data = await paycheckservice.getDepositDetails(essUserKey)
        set((state) => ({ ...state, depositData: _Data }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    getEmployeeResources: async (essUserKey) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        const _Data = await paycheckservice.getEmployeeResources(essUserKey)
        set((state) => ({ ...state, resourceData: _Data }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    clearData: () => {
      set({ depositData: null, loading: false, error: null })
    },
    editDepositDetails: async (
      amount,
      userkey,
      accountnumber,
      accounttype,
      routingnumber,
      depositkey,
      imgdata,
      bank
    ) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await paycheckservice.editDepositDetails(
          amount,
          userkey,
          accountnumber,
          accounttype,
          routingnumber,
          depositkey,
          imgdata,
          bank
        )
        //set((state) => ({ ...state, depositData: _Data }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    deleteDepositDetails: async (depositkey) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await paycheckservice.deleteDepositDetails(depositkey)
        //set((state) => ({ ...state, depositData: _Data }))
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    getpdfblob: async (payid, employeenumber) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await paycheckservice.getpdfblob(payid, employeenumber)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    fetchw2file: async (
      w2id,
      essuserkey,
      obkey,
      year,
      isCorrectionW2,
      seqNo
    ) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await paycheckservice.fetchw2file(
          w2id,
          essuserkey,
          obkey,
          year,
          isCorrectionW2,
          seqNo
        )
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    getpdfbase64: async (storepolicykey) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await paycheckservice.getpdfbase64(storepolicykey)
      } catch (err) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    },
    fetchBankNameByRoutingNumber: async (routingNumber: string) => {
      set((state) => ({ ...state, loading: true }))
      try {
        await delayHttpRequest()
        return await paycheckservice.fetchBankNameByRoutingNumber(routingNumber)
      } catch (err: any) {
        set((state) => ({ ...state, error: err.message }))
      } finally {
        set((state) => ({ ...state, loading: false }))
      }
    }
  }))
)
export { usepaycheckStore }
